import * as API from "./Api";

export const createHelpRequest = (data) => API.post("help-center", data);
